import { render, staticRenderFns } from "./BazaargahTouchPoint.vue?vue&type=template&id=1f706aa7"
import script from "./BazaargahTouchPoint.vue?vue&type=script&lang=js"
export * from "./BazaargahTouchPoint.vue?vue&type=script&lang=js"
import style0 from "./BazaargahTouchPoint.vue?vue&type=style&index=0&id=1f706aa7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports